import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonIcon from './IcomoonIcon';
import { breakpoints , color } from '../../utils/style';

const Popup = styled('div')`
  width: 580px;
  max-height: 80%;
  margin: 0 auto;
  position: fixed;
  top: 10%;
  left: 50%;
  margin-left: -280px;
  z-index: 100;
  padding: 0 40px;
  display: none;
  .popup-content-wrapper {
    background: ${color.black};
    border:1px solid ${color.black};
    padding: 30px;
    overflow-y: auto;
    border-radius: 10px;
    max-height: 80vh;
  }
  &.wide {
    width: 1000px;
    margin-left: -500px;
  }
  &.padded {
    .popup-content-wrapper {
      padding: 50px;
    }
  }
  &.title-orange {
    .h3 {
      color: ${color.orange};
      margin-bottom: 10px;
    }
  }
  
  .h3 {
    margin-top: 0;
  }
  p {
    margin: 10px 0;
  }
  .popup-content {
    overflow-y: auto;
  }
  &.custom-game-popup {
    .h3 {
      max-width: 50%;
      padding-right: 0;
    }
    .popup-content-wrapper {
      max-height: 100vh;
    }
    .popup-content {
      overflow-y: visible;
    }
  }
  &.popup-open {
    display: block;
    -webkit-animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
	  animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }
  @-webkit-keyframes scale-up-center {
    0% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @keyframes scale-up-center {
    0% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  
  @media (max-width: ${breakpoints.lg}) {
    &.wide {
      width: 800px;
      margin-left: -400px;
    }
  }
  
  @media (max-width: ${breakpoints.md}) {
    &.wide {
      width: 500px;
      margin-left: -250px;
    }
    &.custom-game-popup {
      width: 100% !important;
      top: 0;
      margin-left: -50% !important;
      padding: 0;
      .close-button {
        top: 15px;
        right: 15px;
      }
      .popup-content-wrapper {
        padding: 0;
      }
      .h3 {
        position: absolute;
        top: 15px;
        left: 15px;
        z-index: 1;
        max-width: 80%;
      }
    }
  }
  
  @media (max-width: ${breakpoints.xs}) {
    padding: 40px 0 0;
    width: 350px;
    margin-left: -175px;
    top: 2%;
    &.wide {
      width: 350px;
      margin-left: -175px;
    }
    &.padded {
      padding: 50px 20px;
    }
  }
  
  @media (max-width: ${breakpoints.xxs}) {
    width: 300px;
    margin-left: -150px;
    &.wide {
      width: 300px;
      margin-left: -150px;
    }
  }
  
`;

const CloseButton = styled('button')`
  background: none;
  border: none;
  outline: none;
  color: #FFF;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  opacity: 1;
  &:hover, &:active, &:focus {
    opacity: 0.7;
    cursor: pointer;
  }
  @media (max-width: ${breakpoints.xs}) {
    top: 0;
    right: 5px;
  }
`;

const closeHandler = (popupId) => {
  const layout = document.getElementById('all-content');
  if (layout) {
    layout.classList.remove('popup-blocked');
  }
  const popupWindow = document.getElementById(popupId);
  if (popupWindow) {
    popupWindow.classList.remove('popup-open');
  }
};

const invokePopup = (event, popupId) => {
  event.preventDefault();
  const layout = document.getElementById('all-content');
  layout.classList.add('popup-blocked');
  const popupWindow = document.getElementById(popupId);
  popupWindow.classList.add('popup-open');
};

const invokePopupInitial = (popupId) => {
  const layout = document.getElementById('all-content');
  layout.classList.add('popup-blocked');
  const popupWindow = document.getElementById(popupId);
  popupWindow.classList.add('popup-open');
};

const closePopup = (event, popupId) => {
  closeHandler(popupId)
};

const PopupWindow = ( {children, popupId, title, extraClass} ) => {
  const classNames = extraClass ? extraClass + ' popup-window' : 'popup-window';
  return (
    <Popup id={popupId} className={classNames}>
      <CloseButton onClick={() => closeHandler(popupId)} className="close-button">
        <IcomoonIcon icon="gclub-close" color={color.white} size={26}/>
      </CloseButton>
      <div className="popup-content-wrapper">
        {title &&
        <div id={popupId + "-title"} className="h3" dangerouslySetInnerHTML={{ __html: title }}/>
        }
        <div id={popupId + '-content'} className="popup-content">
          {children}
        </div>
      </div>
    </Popup>
  )
};

export default PopupWindow;
export {invokePopup, closePopup, invokePopupInitial};

PopupWindow.propTypes = {
  popupId: PropTypes.string,
  title: PropTypes.string,
  extraClass: PropTypes.string,
};


